module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "scrollTip",
    staticClass: "container"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.icon === 'up') ? _c('div', {
    staticClass: "triggle-icon"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f82af96"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tips/Tips.vue
// module id = 530
// module chunks = 1